import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";
import { t } from "ttag";

import type {
    CocoonHomeCTABlock as HomeCTABlockValue,
    ImageChooserBlock,
} from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

const richtextUnwrap = (value: string | null | undefined): string =>
    (value ?? "").replace(/class=.rich-text./g, "");

const richTextContents = (value: string | null | undefined): string =>
    (value ?? "")
        .replace(/^<div class="rich-text">/, "")
        .replace(/^<div class='rich-text'>/, "")
        .replace(/<\/div>$/, "");

const imageFileSrc = (
    image: Immutable<ImageChooserBlock> | null | undefined,
): string => image?.imageData ?? image?.url ?? "";

export const CocoonHomeCTABlock = (
    props: Immutable<{ value: HomeCTABlockValue }>,
): React.JSX.Element => {
    const value = props.value;
    return (
        <section
            className={concatClassNames([
                styles.homeCtaBlock,
                "home-cta-block",
                getGlobalSpacingClasses(value.spacing),
            ])}
            style={{
                backgroundImage: `url(${imageFileSrc(value.background_image)})`,
            }}
        >
            <div className="l-capped-width">
                <div className={styles.homeCtaBlockContent}>
                    <h2 className={styles.homeCtaBlockTitle}>{value.header}</h2>
                    {/* Legacy rendered rich text inside this p; browsers repaired that into an empty p plus sibling block content. */}
                    <p className={styles.homeCtaBlockSubtitle} />
                    {value.description ? (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: richTextContents(value.description),
                            }}
                        />
                    ) : null}
                    <div className="home-cta-block__button-container">
                        {(value.buttons ?? []).map((link, i) => (
                            <a
                                key={i}
                                className="button home-cta-block__button"
                                href={link.page?.url ?? ""}
                            >
                                {t`Shop`}
                                {link.link_title ? ` ${link.link_title}` : ""}
                            </a>
                        ))}

                        {value.extra_copy ? (
                            <div
                                className={styles.homeCtaBlockExtraCopy}
                                dangerouslySetInnerHTML={{
                                    __html: richtextUnwrap(value.extra_copy),
                                }}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    );
};
